let $ = require('jquery');
const Cookies = require('js-cookie');

$(document).ready(run);

let json_data = null;

function run() {
    google.charts.load('upcoming', {packages: ['geochart'], 'language': 'it'});
    google.charts.setOnLoadCallback(get_data());
}

function get_data() {
    const csrftoken = Cookies.get('csrftoken');

    const ajax_post_settings = {
        async: true,
        url: "/get_punti_di_misura/",
        method: "POST",
        headers: {
            "content-type": "application/json",
            "cache-control": "no-cache",
            "X-CSRFToken": csrftoken
        },
        dataType: "json"
    };

    const ajax_request = $.ajax(ajax_post_settings);

    ajax_request.done(function (response) {
        json_data = response;
        google.charts.setOnLoadCallback(draw_chart);
    });

}

function draw_chart() {
    const data = new google.visualization.DataTable();
    data.addColumn('string', 'Regione');
    data.addColumn('number', 'Punti di misura');
    data.addColumn({
        type: 'string',
        role: 'tooltip',
        'p': {'html': true}//added html version
    });

    $.each(json_data, function (key, value) {
        // TODO: raggruppare i punti di misure delle regioni!!
        let info = `<span class="nowrap">${value.via}<br>${value.comune} (${value.provincia.id})</span>`;
        if (value.note) {
            info = `${info}<br><small>${value.note}</small>`;
        }
        data.addRow([value.provincia.regione.alias, 1, info]);
    });

    const chart_options = {
        region: 'IT',
        displayMode: 'regions',
        legend: 'none',
        colors: ['#5cb85c'],
        tooltip: {isHtml: true},
        resolution: 'provinces'
    };

    const div_chart = document.getElementById('chart');
    const chart = new google.visualization.GeoChart(div_chart);
    chart.draw(data, chart_options);
    // google.visualization.events.addListener(chart, 'regionClick', regionClick);

    // var csv = google.visualization.dataTableToCsv(data);
    // console.log(csv);
}

function regionClick(region) {
    console.log(region);
}
